import Global from '../../global';
//import {eLogLevel} from "../enums";
import loggerLib from './logger-lib';
import buildVersion from '../../version';

function initClientLogger() {
  let logger = require('loglevel').noConflict();
  logger.setLevel(Global.config.clientLogLevel);

  const remote = require('loglevel-plugin-remote');
  //const prefix = require('loglevel-plugin-prefix');

  /*prefix.apply(logger, {
    format(/!*level, name, *!/timestamp) {
      return `client_time[${timestamp}] client_version[${buildVersion}]`;
    },
  });*/

  const customJSON = log => {
    return {
      message:  log.message,
      level: log.level.label,
      timestamp: log.timestamp,
      clientVersion: buildVersion
    };
  };

  remote.apply(logger, {
    url: `${Global.config.clientExternalUrl}/logger`,
    timeout: 0,
    interval: 1000,
    headers: {
      uid: typeof window !== 'undefined' ? window.sc_logger_uid : '-'
    },
    backoff: (interval) => {
      const multiplier = 2;
      const jitter = 0.1;
      const limit = 30000;
      let next = interval * multiplier;
      if (next > limit) next = limit;
      next += next * jitter * Math.random();
      return next;
    },
    capacity: 500,
    stacktrace: {
      depth: 3,
      excess: 0,
    },
    timestamp: loggerLib.timestampFunction,
    format: customJSON,
  });


  return logger;
}

const Logger = (function () {
  let logger;

  return {
    get: function () {
      if (!logger) {
        logger = initClientLogger();
      }
      return logger;
    },
  };

})();

export default Logger;
